// Section: Services Component
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const Services = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const services = [
    {
      title: "Sosyal Medya Yönetimi",
      description: "Markanızın sosyal medya hesaplarını profesyonelce yönetiyor, içerik stratejisi geliştiriyor ve etkileşim oranlarınızı artırıyoruz.",
      icon: "📱"
    },
    {
      title: "Logo Tasarımı",
      description: "Markanızın kimliğini yansıtan, unutulmaz ve etkili logo tasarımları ile kurumsal kimliğinizi güçlendiriyoruz.",
      icon: "🎨"
    },
    {
      title: "Grafik Tasarım",
      description: "Broşür, kartvizit, afiş ve dijital materyaller için yaratıcı grafik tasarımlar ile markanızın görsel dilini oluşturuyoruz.",
      icon: "🖼️"
    },
    {
      title: "Fotoğraf ve Video Çekimi",
      description: "Profesyonel fotoğraf ve video çekimi hizmetleri ile ürünlerinizi ve hizmetlerinizi en etkili şekilde sunuyoruz.",
      icon: "📸"
    },
    {
      title: "Drone Çekimi",
      description: "Hava çekimleri ile projelerinize farklı bir perspektif kazandırıyor, etkileyici görsel materyaller üretiyoruz.",
      icon: "🚁"
    },
    {
      title: "Halı Fotoğraf & Video Çekimi",
      description: "Halı sektörüne özel fotoğraf ve video çekimi ile ürünlerinizi en güzel açılardan görüntülüyoruz.",
      icon: "🏠"
    },
    {
      title: "Açık Hava Reklamları",
      description: "Billboard, tabela ve açık hava reklam tasarımları ile markanızın görünürlüğünü artırıyoruz.",
      icon: "📢"
    },
    {
      title: "Tanıtım Filmi",
      description: "Kurumsal tanıtım filmleri ile markanızın hikayesini sinematik bir dille anlatıyoruz.",
      icon: "🎬"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="hizmetler" className="services-section">
      <div className="services-container">
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="services-header"
        >
          <motion.h2 
            variants={itemVariants}
            className="services-title"
          >
            <span className="services-title-light">Hizmetlerimiz</span>
          </motion.h2>
          <motion.p 
            variants={itemVariants}
            className="services-description"
          >
            Markanızın ihtiyaçlarına özel çözümler sunuyor, her projede mükemmellik hedefliyoruz.
          </motion.p>
        </motion.div>

        <motion.div
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
          className="services-grid"
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ 
                scale: 1.05, 
                transition: { duration: 0.2 }
              }}
              className="service-card"
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-description">{service.description}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Icon Placeholder Comments */}
        {/* 
          Görsel prompt: "minimalistic white line icon representing [service name] on dark background, vector style"
          Her hizmet için özel ikonlar tasarlanacak, koyu arka plan üzerinde beyaz çizgi stilinde
        */}
      </div>
    </section>
  );
};

export default Services;